import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldDateRangeComponent } from './field-date-range.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSnackBarModule } from '@angular/material/snack-bar';



@NgModule({
  declarations: [
    FieldDateRangeComponent
  ],
  exports: [
    FieldDateRangeComponent
  ],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatSnackBarModule
  ]
})
export class FieldDateRangeModule { }
